var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquareUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 480h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64H64C28.65 32 0 60.65 0 96v320C0 451.3 28.65 480 64 480zM16 96c0-26.47 21.53-48 48-48h320c26.47 0 48 21.53 48 48v320c0 26.47-21.53 48-48 48H64c-26.47 0-48-21.53-48-48V96zM131.3 256H176v104C176 373.3 186.7 384 200 384h48c13.25 0 24-10.74 24-24V256h44.69c21.38 0 32.09-25.85 16.97-40.97l-92.68-92.68C236.3 117.7 230.1 115.3 224 115.3S211.7 117.7 207 122.3L114.3 215C99.23 230.1 109.9 256 131.3 256zM125.7 226.3l92.68-92.68C220.4 131.6 222.8 131.3 224 131.3s3.617 .3047 5.656 2.344l92.68 92.68c3.412 3.412 2.35 7.232 1.736 8.719C323.5 236.5 321.5 240 316.7 240H256v120c0 4.412-3.588 8-8 8h-48C195.6 368 192 364.4 192 360V240H131.3c-4.824 0-6.777-3.453-7.393-4.938C123.3 233.6 122.2 229.8 125.7 226.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareUp);
export default __webpack_public_path__ + "static/media/square-up.e14ea063eee1109f5f3ce5bf5943467a.svg";
export { ForwardRef as ReactComponent };